"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var react_i18next_1 = require("react-i18next");
var components_1 = require("stremio/components");
var styles_less_1 = __importDefault(require("./styles.less"));
var Cast = function (_a) {
    var className = _a.className, cast = _a.cast;
    var t = (0, react_i18next_1.useTranslation)().t;
    if (!cast || cast.length === 0) {
        return null;
    }
    var displayCast = cast.slice(0, 5);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(className, styles_less_1.default['cast-section']) },
        react_1.default.createElement("div", { className: styles_less_1.default['cast-label'] }, t('CAST')),
        react_1.default.createElement("div", { className: styles_less_1.default['cast-list'] }, displayCast.map(function (member) { return (react_1.default.createElement("div", { key: member.id, className: styles_less_1.default['cast-button'], onClick: function () {
                window.location.hash = "/search?search=".concat(encodeURIComponent(member.name));
            } },
            react_1.default.createElement("div", { className: styles_less_1.default['cast-image-container'] }, member.profile_path ? (react_1.default.createElement(components_1.Image, { className: styles_less_1.default['cast-image'], src: "https://image.tmdb.org/t/p/w185".concat(member.profile_path), alt: member.name })) : (react_1.default.createElement("div", { className: styles_less_1.default['cast-image-placeholder'] }))),
            react_1.default.createElement("div", { className: styles_less_1.default['cast-info'] },
                react_1.default.createElement("div", { className: styles_less_1.default['cast-name'] }, member.name),
                react_1.default.createElement("div", { className: styles_less_1.default['cast-character'] }, member.character)))); }))));
};
exports.default = Cast;
